export default "__VITE_ASSET__DqmnGNS3__"